module.exports = __webpack_public_path__ + "img/tanzania@4x.a7d5505a.png";